export default __webpack_public_path__ + "static/media/h3.1d690871.jpg";